module.exports = __webpack_public_path__ + "img/hometop1.2e25f86c.png";